"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const theme_1 = require("./theme");
const eyeSvg = ((0, jsx_runtime_1.jsxs)("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: [(0, jsx_runtime_1.jsx)("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }), (0, jsx_runtime_1.jsx)("circle", { cx: "12", cy: "12", r: "3" })] }));
const eyeOffSvg = ((0, jsx_runtime_1.jsxs)("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: [(0, jsx_runtime_1.jsx)("path", { d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" }), (0, jsx_runtime_1.jsx)("line", { x1: "1", y1: "1", x2: "23", y2: "23" })] }));
const defaultInputStyle = {
    width: '100%',
    padding: '12px 44px 12px 12px',
    border: `2px solid ${theme_1.theme.colors.inputBorder}`,
    borderRadius: theme_1.theme.radii.input,
    fontSize: 14,
    background: theme_1.theme.colors.input,
    color: theme_1.theme.colors.text,
    boxSizing: 'border-box',
};
const PasswordInput = (0, react_1.forwardRef)(({ value, onChange, placeholder, required, disabled, style, wrapperStyle, ...rest }, ref) => {
    const [showPassword, setShowPassword] = (0, react_1.useState)(false);
    return ((0, jsx_runtime_1.jsxs)("div", { style: { position: 'relative', ...wrapperStyle }, children: [(0, jsx_runtime_1.jsx)("input", { ref: ref, type: showPassword ? 'text' : 'password', value: value, onChange: onChange, placeholder: placeholder, required: required, disabled: disabled, style: { ...defaultInputStyle, ...style }, ...rest }), (0, jsx_runtime_1.jsx)("button", { type: "button", onClick: () => setShowPassword((prev) => !prev), "aria-label": showPassword ? 'Hide password' : 'Show password', title: showPassword ? 'Hide password' : 'Show password', style: {
                    position: 'absolute',
                    right: 8,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    padding: 6,
                    border: 'none',
                    background: 'transparent',
                    cursor: 'pointer',
                    color: theme_1.theme.colors.textMuted,
                    borderRadius: 4,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }, children: showPassword ? eyeOffSvg : eyeSvg })] }));
});
PasswordInput.displayName = 'PasswordInput';
exports.default = PasswordInput;
